import { useQuery } from '@tanstack/react-query';
import { billingOptions } from '../../constants/billing';
export function useBillings(filter, scope) {
    const { data, isLoading, isSuccess } = useQuery(billingOptions.get(filter, scope));
    return {
        billings: data ?? [],
        loadingBilling: isLoading,
        isSuccess,
    };
}
